import React from "react"

class TypeFilter extends React.Component {
  constructor (props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  
  handleClick(e) {
    this.props.onFilterChange(e.target.name, e.target.value);
  }

  render () {
    return (
      <div className="sidebar-filter">
        <h4 className="is-size-4 has-text-danger">{this.props.heading}</h4>
        <ul>
          {this.props.types.map((type, i) => (
            <li key={i}>
              <div className="buttons has-addons">
                <button
                  className={`button is-flex-grow-5 is-justify-content-flex-start is-radiusless p-0 ${this.props.currentFilter === type.tag && "has-text-danger"}`}
                  onClick={this.handleClick}
                  value={type.tag}
                  name={this.props.name}
                >
                  {type.name}
                </button>
                {this.props.currentFilter === type.tag &&
                  <button
                    className="button is-flex-grow-0 is-flex-shrink-0"
                    onClick={this.handleClick}
                    name={this.props.name}
                    value={null}
                  >
                    &#215;
                  </button>
                }
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default TypeFilter
